var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMGreyClock = function SvgMGreyClock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 23C5.36727 23 0 17.824 0 11.5209C0 5.21779 5.36727 0 12 0C18.6327 0 24 5.17604 24 11.4791C24 17.7822 18.5891 23 12 23Z",
    fill: "#BDBFC4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0393 2.2623C17.3508 2.2623 21.6787 6.40984 21.6787 11.5C21.6787 16.5902 17.3508 20.7377 12.0393 20.7377C6.72787 20.7377 2.4 16.5902 2.4 11.5C2.4 6.40984 6.68852 2.2623 12.0393 2.2623ZM12.0393 0C5.39016 0 0 5.16557 0 11.5C0 17.8344 5.39016 23 12 23C18.6098 23 24 17.8344 24 11.5C24 5.16557 18.6492 0 12.0393 0Z",
    fill: "#8B8C8F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 0V23C19.0951 23 24 17.8429 24 11.5188C24 5.15712 19.059 0 13 0Z",
    fill: "#7A7B7E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0877 5C13.5915 5 14 5.43569 14 5.97314V13.0269C14 13.5643 13.5915 14 13.0877 14H7.91233C7.40846 14 7 13.5643 7 13.0269C7 12.4894 7.40846 12.0537 7.91233 12.0537H12.1753V5.97314C12.1753 5.43569 12.5838 5 13.0877 5Z",
    fill: "#002C3B"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMGreyClock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mGreyClock.d7207b58.svg";
export { ForwardRef as ReactComponent };